/* ENEA lightweight wishlist (2026-06-27)
 * Self contained, browser based (localStorage). Replaces the Appmate app.
 * Adds: a square heart on product pages (next to Add to Bag), a header heart
 * with a count that opens a slide-out wishlist drawer (no page navigation, so
 * it works the same in draft preview and live), and also renders the standalone
 * /pages/wishlist page for direct visits.
 * 2026-08-31: also places a bookmark on product grid cards (injectCards).
 * To revert: delete this file + its script tag in snippets/loading.liquid.
 */
(function () {
  if (window.__eneaWishlist) return; window.__eneaWishlist = true;

  var CSS = [
    '.enea-wish-btn{display:inline-flex;align-items:center;justify-content:center;background:none;border:0;cursor:pointer;color:#171412;padding:0;line-height:0}',
    '.enea-wish-btn svg{fill:none;stroke:currentColor;stroke-width:3.2;transition:fill .15s ease}',
    '.enea-wish-btn.is-wished svg{fill:#171412;stroke:#171412}',
    '.enea-wish-pdp-wrap{margin-top:14px}',
    '.enea-wish-btn--pdp{gap:8px;font-size:.8rem;letter-spacing:.05em;text-transform:uppercase}',
    '.enea-wish-btn--pdp svg{width:18px;height:18px}',
    '.enea-wish-pdp-label{line-height:1}',
    '.enea-wish-header{position:relative;display:inline-flex;align-items:center;justify-content:center}',
    '.enea-wish-header,.enea-wish-header *{cursor:pointer !important}',
    '.enea-wish-header svg{fill:none;stroke:currentColor;stroke-width:4.5;width:22px;height:22px}',
    '.enea-wish-badge{position:absolute;top:-6px;right:-8px;min-width:16px;height:16px;padding:0 4px;border-radius:9px;background:#171412;color:#fff;font-size:10px;line-height:16px;text-align:center}',
    'a[href*="/apps/wishlist"],wishlist-button-product,.wk-button,wishlist-button-list{display:none!important}',
    '.product__submit__buttons:has(.enea-wish-square--col){grid-template-columns:1fr auto;align-items:stretch}',
    '.product__submit__item:has(.enea-wish-square){display:flex;align-items:stretch;gap:4px}',
    '.product__submit__item:has(.enea-wish-square) .product__submit__add,.product__submit__item:has(.enea-wish-square) [name="add"]{flex:1 1 auto;min-width:0}',
    '.enea-wish-square{width:56px;min-width:56px;height:auto;min-height:55px;align-self:stretch;border-radius:0;background:#2a4249;color:#fff;flex:0 0 auto;padding:0 10px}',
    '.enea-wish-square svg{width:22px;height:22px;stroke:#fff;fill:none}',
    '.enea-wish-square.is-wished svg{fill:#fff;stroke:#fff}',
    /* product grid card bookmark (2026-08-31) - placement lives in snippets/enea-collection-card.liquid */
    '.enea-wish-grid-btn svg{width:15px;height:15px;stroke-width:4.5}',
    /* drawer */
    '.enea-wish-overlay{position:fixed;inset:0;background:rgba(0,0,0,.4);z-index:9998;opacity:0;visibility:hidden;transition:opacity .28s ease}',
    '.enea-wish-overlay.is-open{opacity:1;visibility:visible}',
    '.enea-wish-drawer{position:fixed;top:0;right:0;height:100%;width:390px;max-width:88vw;background:#fff;z-index:9999;transform:translateX(100%);transition:transform .28s ease;box-shadow:-2px 0 14px rgba(0,0,0,.15);display:flex;flex-direction:column}',
    '.enea-wish-drawer.is-open{transform:translateX(0)}',
    '.enea-wish-drawer__head{display:flex;align-items:center;justify-content:space-between;padding:18px 20px;border-bottom:1px solid #eee;flex:0 0 auto}',
    '.enea-wish-drawer__title{font-size:.95rem;letter-spacing:.08em;text-transform:uppercase;margin:0}',
    '.enea-wish-drawer__close{background:none;border:0;font-size:26px;line-height:1;cursor:pointer;color:#171412;padding:0 4px}',
    '.enea-wish-drawer__body{flex:1;overflow-y:auto;padding:6px 20px 20px}',
    '.enea-wish-line{display:flex;gap:14px;padding:16px 0;border-bottom:1px solid #f0eee9;position:relative}',
    '.enea-wish-line__img{width:66px;height:82px;flex:0 0 auto;object-fit:cover;background:#f4f2ee;display:block}',
    '.enea-wish-line__info{flex:1;min-width:0;display:flex;flex-direction:column}',
    '.enea-wish-line__title{font-size:.9rem;color:#171412;text-decoration:none;margin:0 0 6px;line-height:1.3}',
    '.enea-wish-line__price{font-size:.85rem;color:#171412;margin-bottom:10px}',
    '.enea-wish-line__view{font-size:.72rem;letter-spacing:.08em;text-transform:uppercase;color:#171412;text-decoration:underline;align-self:flex-start}',
    '.enea-wish-line__remove{position:absolute;top:14px;right:0;background:none;border:0;font-size:20px;line-height:1;cursor:pointer;color:#9a948c}',
    '.enea-wish-empty{text-align:center;padding:50px 10px}',
    '.enea-wish-empty p{margin-bottom:20px;font-size:1.05rem}',
    /* standalone page */
    '.enea-wish-grid{display:grid;grid-template-columns:repeat(2,1fr);gap:20px;max-width:1100px;margin:0 auto;padding:20px}',
    '@media(min-width:768px){.enea-wish-grid{grid-template-columns:repeat(4,1fr);gap:30px}}',
    '.enea-wish-card{position:relative;text-align:center}',
    '.enea-wish-card__img{display:block;aspect-ratio:4/5;overflow:hidden;background:#f4f2ee}',
    '.enea-wish-card__img img{width:100%;height:100%;object-fit:cover;display:block}',
    '.enea-wish-card__title{display:block;margin:10px 0 4px;font-size:.95rem;color:#171412;text-decoration:none}',
    '.enea-wish-card__price{font-size:.9rem;color:#171412;margin-bottom:10px}',
    '.enea-wish-card__cta{display:inline-block}',
    '.enea-wish-remove{position:absolute;top:8px;right:8px;z-index:3;width:28px;height:28px;border-radius:50%;border:0;background:rgba(255,255,255,.9);font-size:18px;line-height:1;cursor:pointer;color:#171412;box-shadow:0 1px 4px rgba(0,0,0,.12)}'
  ].join('');
  try { var st = document.createElement('style'); st.setAttribute('data-enea-wishlist', ''); st.textContent = CSS; (document.head || document.documentElement).appendChild(st); } catch (e) {}

  var KEY = 'enea_wishlist_v1';
  var HEART = '<svg viewBox="-5 -5 74 74" width="20" height="20" aria-hidden="true" focusable="false"><path d="M12 3 H52 V61 L32 46.8 L12 61 Z"/></svg>'; /* 2026-07-01: bookmark icon (was heart) per brand direction; widened 2026-07-02 */

  /* PERF 2026-09-02: read() used to JSON.parse localStorage on EVERY call, and the
     sync pass calls has() once per button - dozens of parses per pass, with passes
     repeating from the MutationObserver for the whole load window. GTmetrix put
     this file at 516ms of scripting on a collection page. The list is now parsed
     once and cached; the cache invalidates on our own writes and on the storage
     event, which also keeps two open tabs in step (they previously only synced on
     the next full pass). */
  /* The cache revalidates against the RAW stored string on every read: getItem is
     microseconds (it is the JSON.parse that cost the 516ms), and comparing strings
     means a write by anything else in this tab, or a failed setItem (private mode,
     quota), can never leave the UI showing a list that storage does not hold -
     both were adversarial-review findings on the first draft of this cache. */
  var cacheRaw = null, cacheList = null;
  function read() {
    var raw = null;
    try { raw = localStorage.getItem(KEY); } catch (e) {}
    if (cacheList !== null && raw === cacheRaw) return cacheList;
    cacheRaw = raw;
    try { cacheList = JSON.parse(raw) || []; } catch (e) { cacheList = []; }
    return cacheList;
  }
  function write(list) {
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    cacheRaw = null; cacheList = null;
    sync();
  }
  function has(h) { return read().indexOf(h) !== -1; }
  function toggle(h) { var l = read(); var i = l.indexOf(h); if (i === -1) l.unshift(h); else l.splice(i, 1); write(l); return i === -1; }
  window.addEventListener('storage', function (e) { if (e.key === KEY) { cacheRaw = null; cacheList = null; try { sync(); } catch (err) {} } });

  function handleFrom(href) {
    if (!href) return null;
    var rest = href.split('/products/')[1];
    if (!rest) return null;
    return rest.split('?')[0].split('#')[0].split('/')[0] || null;
  }
  /* 2026-10-29: each Shopify placeholder now gets its own separators. All of them used
     to get the browser-locale number, so EUR shoppers (format
     "€{{amount_with_comma_separator}}") saw "€208.95" in the wishlist while every other
     price on the site read "€208,95". */
  function sep(amount, decimals, thou, dec) {
    var p = amount.toFixed(decimals).split('.');
    p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
    return p.length > 1 ? p[0] + dec + p[1] : p[0];
  }
  function money(cents) {
    var fmt = (window.theme && window.theme.moneyFormat) || (window.Shopify && window.Shopify.money_format) || '';
    var amount = (cents / 100);
    var n = amount.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    if (fmt && fmt.indexOf('{{') !== -1) {
      var tmp = fmt
        .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, sep(amount, 0, '.', ','))
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, sep(amount, 2, '.', ','))
        .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, sep(amount, 0, ',', '.'))
        .replace(/\{\{\s*amount\s*\}\}/g, sep(amount, 2, ',', '.'));
      var d = document.createElement('div'); d.innerHTML = tmp; return (d.textContent || d.innerText || '').trim();
    }
    return n;
  }
  function productData(p) {
    var img = (p.featured_image || (p.images && p.images[0]) || '');
    if (img && img.indexOf('http') !== 0 && img.indexOf('//') !== 0) img = 'https:' + img;
    return {
      url: p.url,
      title: (p.title || '').split(' - ')[0],
      img: img,
      price: money((typeof p.price_min === 'number') ? p.price_min : p.price)
    };
  }
  function fetchProduct(handle) {
    return fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { return p ? productData(p) : null; })
      .catch(function () { return null; });
  }
  function sized(img, w) { return img ? img.replace(/(\.[a-zA-Z]+)(\?|$)/, '_' + w + 'x$1$2') : ''; }

  /* Every DOM write below is guarded to only fire when the value actually changes.
     Not cosmetic: an unconditional setAttribute/textContent fires a mutation record
     even for the same value, and this file's own MutationObserver was re-triggering
     itself off sync()'s badge write on every pass - a quiet infinite loop of scans
     that predates the 2026-09-02 refactor (adversarial-review finding). */
  function sync() {
    var list = read(); var n = list.length;
    var set = {}; for (var i = 0; i < n; i++) set[list[i]] = 1;
    document.querySelectorAll('[data-enea-wish-count]').forEach(function (el) {
      var t = String(n); if (el.textContent !== t) el.textContent = t;
      var d = n > 0 ? '' : 'none'; if (el.style.display !== d) el.style.display = d;
    });
    document.querySelectorAll('[data-enea-wish-btn]').forEach(function (b) {
      var h = b.getAttribute('data-enea-wish-btn'); var on = set[h] === 1;
      b.classList.toggle('is-wished', on);
      var v = on ? 'true' : 'false'; if (b.getAttribute('aria-pressed') !== v) b.setAttribute('aria-pressed', v);
    });
  }

  /* The click reads the handle off the ATTRIBUTE at click time, never from the
     closure. 2026-09-03 bug (owner's dev spotted it on his own copy): grid cards
     swap to a sibling product when a metal swatch is picked, but the bookmark
     kept the handle it was created with - pick White Gold, tap save, and the
     Yellow Gold product went into the wishlist. injectCards now keeps the
     attribute in step with the card's current link, and because the handler
     reads the attribute, the saved product always matches the metal on show. */
  function makeBtn(handle, cls) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'enea-wish-btn ' + (cls || ''); b.setAttribute('data-enea-wish-btn', handle);
    b.setAttribute('aria-label', 'Save to wishlist'); b.innerHTML = HEART;
    b.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      var h = b.getAttribute('data-enea-wish-btn') || handle;
      /* grid buttons resolve against the card AT CLICK TIME: the swatch swap
         rewrites the card's product links synchronously enough that reading
         them here can never lose the race the observer pass could (it is
         throttled, and paused entirely in background tabs) */
      var cardEl = b.closest('.product-grid-item');
      if (cardEl) {
        var link = cardEl.querySelector('a[href*="/products/"]');
        var lh = handleFrom(link && link.getAttribute('href'));
        if (lh) h = lh;
      }
      if (h !== b.getAttribute('data-enea-wish-btn')) b.setAttribute('data-enea-wish-btn', h);
      toggle(h);
    });
    return b;
  }

  function isShown(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 2 && r.height > 2 && el.offsetParent !== null; }
  function injectPDP() {
    if (!document.body.classList.contains('template-product')) return;
    var handle = handleFrom(location.pathname); if (!handle) return;
    // Always target an Add to Bag button that lives in the real submit row.
    // There can be several add buttons on the page (quick view, sticky bar, etc),
    // so never just grab the first one; require it to be inside the submit row.
    var adds = [].slice.call(document.querySelectorAll('.product__submit__add, button[name="add"]'));
    var inRow = adds.filter(function (b) { return b.closest('.product__submit__item') || b.closest('.product__submit__buttons'); });
    var preferred = inRow.filter(isShown)[0] || inRow[0];
    if (preferred) {
      var item = preferred.closest('.product__submit__item') || preferred.closest('.product__submit__buttons');
      if (item.querySelector('.enea-wish-square')) return; // already placed correctly
      // self-heal: remove any earlier labelled fallback that may have been placed first
      var stale = document.querySelector('.enea-wish-pdp-wrap'); if (stale) stale.remove();
      item.appendChild(makeBtn(handle, 'enea-wish-square enea-wish-pdp'));
      try {
        item.style.display = 'flex'; item.style.alignItems = 'stretch'; item.style.gap = '4px';
        if (preferred.style) { preferred.style.flex = '1 1 auto'; preferred.style.minWidth = '0'; }
      } catch (e) {}
      return;
    }
    // only if there is genuinely no submit row on the page: a single labelled fallback
    if (document.querySelector('.enea-wish-pdp')) return;
    var anchor = document.querySelector('.product__form') || document.querySelector('.product__block');
    if (!anchor) return;
    var wrap = document.createElement('div'); wrap.className = 'enea-wish-pdp-wrap';
    var btn = makeBtn(handle, 'enea-wish-btn--pdp enea-wish-pdp');
    var label = document.createElement('span'); label.className = 'enea-wish-pdp-label'; label.textContent = 'Save to wishlist';
    btn.appendChild(label);
    wrap.appendChild(btn); anchor.appendChild(wrap);
  }

  /* ---- product grid cards (2026-08-31) ----
   * The Mejuri-style card puts the bookmark in the top right of the info block.
   * It is injected here, rather than rendered in Liquid, so it shares makeBtn and
   * therefore the same click handler, storage and is-wished state as the product
   * page and header. Buttons are NOT event delegated in this file, so markup added
   * by anything else would be inert.
   *
   * Collection pages and the homepage, matching the card styling scope in
   * snippets/enea-collection-card.liquid.
   *
   * #MainContent is required, not cosmetic: the theme renders the SAME card markup
   * for the header mega menu and mobile nav, which sit outside #MainContent. Without
   * this scope a bookmark was being planted on every menu card too (20 of the 44
   * cards on a collection page are menu cards). (2026-09-01)
   *
   * Runs again from the MutationObserver below, which is what covers infinite scroll
   * and carousel re-renders.
   */
  function injectCards() {
    var cls = document.body.classList;
    if (!cls.contains('template-collection') && !cls.contains('template-index')) return;
    var main = document.getElementById('MainContent');
    if (!main) return;
    var cards = main.querySelectorAll('.product-grid-item');
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var info = card.querySelector('.product-grid-item__info');
      if (!info) continue;
      var link = card.querySelector('a[href*="/products/"]');
      var handle = handleFrom(link && link.getAttribute('href'));
      if (!handle) continue;
      var existing = info.querySelector('[data-enea-wish-btn]');
      if (existing) {
        /* the swatch swap rewrote the card's links to a sibling product; keep
           the bookmark pointing at what the card now shows (see makeBtn note) */
        if (existing.getAttribute('data-enea-wish-btn') !== handle) {
          existing.setAttribute('data-enea-wish-btn', handle);
        }
        continue;
      }
      info.appendChild(makeBtn(handle, 'enea-wish-grid-btn'));
    }
  }

  /* ---- slide-out drawer (header heart) ---- */
  var drawer, overlay;
  function buildDrawer() {
    if (drawer) return;
    overlay = document.createElement('div'); overlay.className = 'enea-wish-overlay';
    drawer = document.createElement('aside'); drawer.className = 'enea-wish-drawer'; drawer.setAttribute('aria-label', 'Wishlist');
    drawer.innerHTML =
      '<div class="enea-wish-drawer__head"><h2 class="enea-wish-drawer__title">Wishlist</h2><button type="button" class="enea-wish-drawer__close" aria-label="Close">&times;</button></div>' +
      '<div class="enea-wish-drawer__body" data-enea-wish-body></div>';
    document.body.appendChild(overlay); document.body.appendChild(drawer);
    overlay.addEventListener('click', closeDrawer);
    drawer.querySelector('.enea-wish-drawer__close').addEventListener('click', closeDrawer);
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }
  function openDrawer() { buildDrawer(); renderDrawer(); overlay.classList.add('is-open'); drawer.classList.add('is-open'); }
  function closeDrawer() { if (drawer) { drawer.classList.remove('is-open'); overlay.classList.remove('is-open'); } }
  function renderDrawer() {
    var body = drawer.querySelector('[data-enea-wish-body]');
    var list = read();
    if (!list.length) { body.innerHTML = '<div class="enea-wish-empty"><p>Your wishlist is empty.</p><a class="btn btn--primary btn--solid" href="/collections/all">Start exploring</a></div>'; return; }
    body.innerHTML = '';
    list.forEach(function (handle) {
      var line = document.createElement('div'); line.className = 'enea-wish-line';
      line.innerHTML = '<div class="enea-wish-line__info"><span class="enea-wish-line__title">Loading...</span></div>';
      body.appendChild(line);
      fetchProduct(handle).then(function (p) {
        if (!p) { line.remove(); return; }
        line.innerHTML =
          '<a href="' + p.url + '"><img class="enea-wish-line__img" src="' + sized(p.img, 200) + '" alt="" loading="lazy"></a>' +
          '<div class="enea-wish-line__info">' +
            '<a class="enea-wish-line__title" href="' + p.url + '">' + p.title + '</a>' +
            '<span class="enea-wish-line__price">' + p.price + '</span>' +
            '<a class="enea-wish-line__view" href="' + p.url + '">View product</a>' +
          '</div>' +
          '<button type="button" class="enea-wish-line__remove" aria-label="Remove">&times;</button>';
        line.querySelector('.enea-wish-line__remove').addEventListener('click', function () { toggle(handle); line.remove(); if (!read().length) renderDrawer(); });
      });
    });
  }

  function makeHeaderHeart(extraCls) {
    var a = document.createElement('a');
    a.href = '#'; a.className = 'enea-wish-header ' + (extraCls || ''); a.setAttribute('aria-label', 'Wishlist'); a.setAttribute('data-enea-wish-header', '');
    a.innerHTML = HEART + '<span class="enea-wish-badge" data-enea-wish-count style="display:none">0</span>';
    a.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); openDrawer(); }, true);
    return a;
  }
  function injectHeader() {
    // place a heart next to every header cart icon (desktop bar + mobile bar), so it
    // shows on whichever header is visible at the current breakpoint
    var carts = [].slice.call(document.querySelectorAll('a.cart__toggle, [data-cart-drawer-toggle], .menu__item--icons a[href*="/cart"], .header__icons a[href*="/cart"], header a[href$="/cart"]'));
    carts.forEach(function (cart) {
      // never inject inside the cart drawer / mini-cart / any popup, only the header bars
      if (cart.closest('cart-drawer, .cart-drawer, .cart-drawer__head, .mini-cart, .drawer--cart, [class*="drawer"], [class*="popup"], [class*="modal"]')) return;
      var container = cart.parentNode; if (!container) return;
      if (container.querySelector('[data-enea-wish-header]')) return;
      var cls = /mobile-menu__button/.test(cart.className) ? 'mobile-menu__button' : 'navlink navlink--icon';
      container.insertBefore(makeHeaderHeart(cls), cart);
    });
  }

  /* ---- standalone /pages/wishlist page ---- */
  function renderPage() {
    var root = document.querySelector('#enea-wishlist-root, [data-enea-wishlist-root]');
    if (!root) return;
    var list = read();
    if (!list.length) { root.innerHTML = '<div class="enea-wish-empty"><p>Your wishlist is empty.</p><a class="btn btn--primary btn--solid" href="/collections/all">Start exploring</a></div>'; return; }
    root.innerHTML = '<div class="enea-wish-grid" data-enea-wish-grid></div>';
    var grid = root.querySelector('[data-enea-wish-grid]');
    list.forEach(function (handle) {
      fetchProduct(handle).then(function (p) {
        if (!p) return;
        var el = document.createElement('div'); el.className = 'enea-wish-card';
        el.innerHTML =
          '<button type="button" class="enea-wish-remove" data-enea-wish-btn="' + handle + '" aria-label="Remove">&times;</button>' +
          '<a class="enea-wish-card__img" href="' + p.url + '">' + (p.img ? '<img src="' + sized(p.img, 600) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<a class="enea-wish-card__title" href="' + p.url + '">' + p.title + '</a>' +
          '<div class="enea-wish-card__price">' + p.price + '</div>' +
          '<a class="btn btn--primary btn--solid btn--small enea-wish-card__cta" href="' + p.url + '">View</a>';
        el.querySelector('.enea-wish-remove').addEventListener('click', function () { toggle(handle); el.remove(); if (!read().length) renderPage(); });
        grid.appendChild(el);
      });
    });
  }

  function init() { [injectHeader, injectPDP, injectCards, renderPage, sync].forEach(function (f) { try { f(); } catch (e) {} }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();

  // re-run for lazy / dynamically added content (header, pdp, grid cards) (throttled)
  /* PERF 2026-09-02: the pass used to run on a plain 800ms timer after any mutation,
     which on a busy load (this page keeps mutating for ~30s: lazy images, carousels,
     app scripts) meant full-DOM rescans right through the window users interact in.
     Now: at least 1500ms between passes, the work itself runs in an idle slot so it
     never competes with input or rendering, and a hidden tab defers the pass until
     it becomes visible again. Injection latency for infinite-scroll cards moves
     from <=0.8s to <=1.5s+idle, which is invisible next to the scroll itself. */
  var pending = null, lastPass = 0, waitingVisible = false;
  var idle = window.requestIdleCallback ? window.requestIdleCallback.bind(window) : function (f) { return setTimeout(f, 200); };
  function runPass() {
    pending = null;
    if (document.hidden) {
      /* one listener max, however many mutation cycles arrive while hidden */
      if (!waitingVisible) {
        waitingVisible = true;
        document.addEventListener('visibilitychange', function () { waitingVisible = false; schedulePass(); }, { once: true });
      }
      return;
    }
    lastPass = Date.now();
    try { injectHeader(); injectPDP(); injectCards(); sync(); } catch (e) {}
  }
  function schedulePass() {
    if (pending) return;
    var wait = Math.max(200, 1500 - (Date.now() - lastPass));
    pending = setTimeout(function () { idle(runPass, { timeout: 2000 }); }, wait);
  }
  var mo = new MutationObserver(schedulePass);
  /* PERF 2026-07-01: observe only after window load (init already ran at DOMContentLoaded);
     re-run init once at observe start so nothing replaced between DCL and load is missed. */
  function startObserver() { try { init(); lastPass = Date.now(); mo.observe(document.body, { childList: true, subtree: true }); } catch (e) {} }
  if (document.readyState === 'complete') startObserver(); else window.addEventListener('load', startObserver);
})();
